import AbstractPage from "sources/ts/pages/AbstractPage";
import YouTubeElement from "sources/ts/modules/YouTubeElement";
import Slider from "sources/ts/modules/Slider";
import Share from "sources/ts/modules/share";
import ParallaxBackground from '../modules/ui/ParallaxBackground';
import Breakpoint from "frontools/core/Breakpoint";


/**
    * Page description
    * (c) lg2fabrique 2017
*/

export default class Page extends AbstractPage {

    private _partnersSlider : Slider;

    /**
    * constructor
    */
    constructor() {
        super();

        const video = new YouTubeElement('rtztSnjPtkE', document.querySelector('.video'));
        const sharer = new Share();

        new ParallaxBackground();

        this._partnersSlider = new Slider();

        // Breakpoint.on('group_desktop', this._onResizeDesktop.bind(this));
        // Breakpoint.on('group_mobile', this._onResizeMobile.bind(this));

    }

    // init elements
    protected _onResizeDesktop() {
        if (this._partnersSlider) this._partnersSlider.destroy();
    }

    // init elements
    protected _onResizeMobile() {
        this._partnersSlider = new Slider();
    }
}
